import { PortableTextTypeComponent } from '@portabletext/react'
import React from 'react'
import { FactBoxSerializer } from '../serializers/componentTypes/FactBoxSerializer'
import { QuoteListSerializer } from '../serializers/componentTypes/QuoteListSerializer'

export const getTwoColumnsOneStickyComponentTypes = (): Record<
  string,
  PortableTextTypeComponent
> => ({
  factBox: ({ value }) => <FactBoxSerializer {...value} />,
  quoteList: ({ value }) => <QuoteListSerializer {...value} />,
})
